//@flow
import React from 'react';

export default function OfficeLogos() {
  return (
    <div className="office-logos">
      <div className="row">
        <div className="columns large-12 xlarge-6"><div className="office-logo logo-1"></div></div>
        <div className="columns large-12 xlarge-6"><div className="office-logo logo-2"></div></div>
      </div>
    </div>
  );
}
